import React, { useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/omega/theme.css';
import {confirmKYC} from '../../actions/kyc';
import {newAccountOpeningRoutes} from '../../routers/routes'
import EntityDocsComponent from "./EntityDocsComponent";
import RelatedPartiesComponent from "./related/RelatedPartiesComponent";
import SignatoriesComponent from "./signatories/SignatoriesComponent";
import ButtonsComponent from "../ButtonsComponent";

export const kyc = (props) => {

    const application = useSelector(state => state.application && state.application.application);
    const entityDocs = useSelector(state => state.application.application && state.application.application.legalEntity.supportingDocuments ? state.application.application.legalEntity.supportingDocuments : []);
    const systemError = useSelector(state => state.systemError);

    const [errors, setErrors] = useState({});


    const entityDocsRef = React.useRef(null);
    const signatoriesRef = React.useRef(null);
    const relatedPartyRef = React.useRef(null);

    const dispatch = useDispatch();


    const saveAndContinue = (event) => {
        props.history.push('/saveapplication');
    }

    const saveDetails = (event) => {
        event.preventDefault();
        const isDocsValid = entityDocsRef.current && entityDocsRef.current.validateDocs();
        const isSignatoriesValid = signatoriesRef.current && signatoriesRef.current.validateSignatories();
        const isRelatedPartiesValid = relatedPartyRef.current && relatedPartyRef.current.validateRelatedParties();
        const {history} = props;
        if (isDocsValid && isSignatoriesValid && isRelatedPartiesValid) {
            const onProceed = () => history && history.push(newAccountOpeningRoutes.confirmauthorisers);
            dispatch(confirmKYC(application.id, onProceed));
        }
    }

    const renderFooter = () => {
        const {history} = props;
        return (
            <ButtonsComponent
                history={history}
                onNext={saveDetails}
                prevPage={newAccountOpeningRoutes.confirmproduct}
                onSaveAndContinue={saveAndContinue}
            />
        )
    }

    if (systemError && systemError.show) return null;
    return (
        <div className="page-container">
            <div className="container-fluid" style={{minHeight: "50em"}}>
                <div className="col-md-4">
                    <EntityDocsComponent
                        ref={entityDocsRef}
                        applicationId={application.id}
                        entityDocs={entityDocs}
                    />

                </div>
                <div className="col-md-4">
                    <SignatoriesComponent ref={signatoriesRef}/>
                </div>
                <div className="col-md-4">
                    <RelatedPartiesComponent ref={relatedPartyRef}/>
                </div>
            </div>
            < div
                className="page-footer-section">
                {renderFooter()}
            </div>
        </div>
    );

}

export default kyc;
